import { memo } from "react";
import { Draggable, Droppable } from "@hello-pangea/dnd";
import { Inbox } from "lucide-react";
import { STATUS_DOT, slug } from "@/lib/constants";
import { fmtINR } from "@/lib/format";
import { LeadCard } from "./LeadCard";

const dragStyle = (style, snapshot) => (snapshot.isDropAnimating ? { ...style, transitionDuration: "0.001s" } : style);

export const KanbanColumn = memo(function KanbanColumn({ status, leads, repsById, today, onOpen, onMove, onTouch }) {
  const s = slug(status);
  const total = leads.reduce((sum, l) => sum + (Number(l.total_deal_value) || 0), 0);
  return (
    <section data-testid={`kanban-column-${s}`} className="kanban-col">
      <header className="flex items-center justify-between px-1 pb-3">
        <div className="flex items-center gap-2 min-w-0">
          <span className={`h-2 w-2 rounded-full ${STATUS_DOT[status]}`} />
          <h2 className="font-display text-sm font-bold text-slate-100 truncate">{status}</h2>
          <span data-testid={`kanban-column-count-${s}`} className="count-chip">{leads.length}</span>
        </div>
        <span className="font-mono text-[11px] text-slate-400">{fmtINR(total)}</span>
      </header>
      <Droppable droppableId={status}>
        {(provided, snap) => (
          <div ref={provided.innerRef} {...provided.droppableProps}
            className={`flex min-h-[140px] flex-1 flex-col gap-2.5 rounded-xl p-1.5 transition-colors ${snap.isDraggingOver ? "bg-indigo-500/15 ring-1 ring-indigo-500/40" : ""}`}>
            {leads.length === 0 && !snap.isDraggingOver && (
              <div data-testid={`kanban-column-empty-${s}`} className="flex flex-col items-center justify-center gap-1.5 rounded-lg border border-dashed border-slate-700 py-8 text-xs text-slate-500">
                <Inbox className="h-4 w-4" /> No leads here yet
              </div>
            )}
            {leads.map((lead, i) => (
              <Draggable key={lead.id} draggableId={lead.id} index={i}>
                {(dp, ds) => (
                  <div ref={dp.innerRef} {...dp.draggableProps} {...dp.dragHandleProps} style={dragStyle(dp.draggableProps.style, ds)}>
                    <LeadCard lead={lead} today={today} onOpen={onOpen} onMove={onMove} onTouch={onTouch} dragging={ds.isDragging}
                      setterName={repsById[lead.setter_id]?.name} closerName={repsById[lead.closer_id]?.name} />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </section>
  );
});
